<template>
  <b-row>
    <b-col class="pl-0 pr-0" :class="{ 'center-align': left != 0 }" v-model="rating">
      <b-img
        src="img/star-full.jpg"
        class="review-stars"
        v-if="rating > 1"
      ></b-img>
      <b-img
        src="img/star-full.jpg"
        class="review-stars"
        v-if="rating > 2"
      ></b-img>
      <b-img
        src="img/star-full.jpg"
        class="review-stars"
        v-if="rating > 3"
      ></b-img>
      <b-img
        src="img/star-full.jpg"
        class="review-stars"
        v-if="rating > 4"
      ></b-img>
      <b-img
        src="img/star-full.jpg"
        class="review-stars"
        v-if="rating != 0 && (rating % 1) == 0"
      ></b-img>

      <b-img
        src="img/star-half.jpg"
        class="review-stars"
        v-else-if="rating != 0 && (rating % 1)<= 0.5"
      ></b-img>
      <b-img
        src="img/star-48.jpg"
        class="review-stars"
        v-else-if="rating != 0 && (rating % 1)> 0.5"
      ></b-img>
      <span style="padding-left: 10px; height: 1.2rem; vertical-align: top" 
      v-if="count>0"
        ><b style="line-height: 1.2rem; font-size: 1rem"
          >{{ rating.toFixed(1) }}/5</b
        >

        <b v-if="brief!=0">
          <u
            style="
              line-height: 1.2rem;
              font-size: 1rem;
              margin-left: 10px;
              cursor: pointer;
            "
            @click="gotoreview(reviewproductid)"
            >{{ count }} Reviews</u
          ></b
        >
      </span>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "ReviewPanel",
  data: function () {
    return {
      rating: 0,
      count: 0,
      brief: 0,
      left:0,
      reviewproductid: "t1"
    };
  },
  methods: {
    update(rating, count, brief, left, reviewproductid) {
      if(rating>5) rating = 5;
      if(rating<4.1) rating = 4.1
      this.rating = rating;
      this.count = count;
      this.brief = brief;
      this.left = left;
      this.reviewproductid = reviewproductid;
    },
    gotoreview(key) {
      window.location.href = "/#/review?product=" + key;
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 768px) {
  .review-stars {
    width: 18px !important;
    margin-right: 1px !important;
  }
}

.review-stars {
  width: 20px;
  margin-right: 2px;
  vertical-align: top;
}

.center-align{
  text-align:center!important;
}
</style>

